import type { FC } from 'react';
import type { CategoryNavigationItem, ParentNavigation } from '../../api/rest/types';
import { CategoryFilterStandalone } from '../CategoryFilterStandalone';
import { useCategoryDataForFilterNavigationMobile } from './useCategoryDataForFilterNavigationMobile';

export type CategoryFilterNavigationMobileProps = {
  /** Category items for list navigation */
  items: CategoryNavigationItem[];
  /** Root category for upwards navigation */
  root: ParentNavigation;
  /** Callback invoked when a category is selected */
  onNavigate?: () => void;
};

/**
 * Displays a single level of categories as navigation items, including upwards if possible.
 * */
export const CategoryFilterNavigationMobile: FC<CategoryFilterNavigationMobileProps> = ({
  items,
  root,
  onNavigate,
}) => {
  const categories = useCategoryDataForFilterNavigationMobile(items, root);

  return <CategoryFilterStandalone categories={categories} onNavigate={onNavigate} />;
};
